/**
 * Экран «Склад» (инвентаризация) — tenant-app, волна 3 «Облака».
 *
 * Состояние бэка: internal/inventory/http_app — все ручки (POST/GET/PUT/
 * DELETE /v1/inventory) сейчас возвращают 501 Not Implemented
 * (shared.WriteNotImplemented). Реальных данных склада ещё нет.
 *
 * Поэтому, согласно правилу feedback_build_to_design_not_api_i18n_mobile
 * (никаких фейк-данных и англ-кодов «Inventory»): показываем аккуратную
 * русскую страницу-состояние по стилю manager v3 — что такое модуль склада
 * и что будет доступно, когда модуль включат. Без выдуманных позиций/таблиц.
 *
 * Дизайн: manager v3 (Inventory addon) — категории остатков (продукты,
 * текстиль, расходники, химия), журнал движений, импорт по чекам (OCR #35).
 * Здесь — превью этих возможностей в «скоро» состоянии.
 *
 * i18n: 100% RU. Мобайл 375: одноколоночный stack.
 */
import { Card } from '@hsc/ui';

interface Capability {
  icon: string;
  title: string;
  desc: string;
}

/** Возможности модуля склада из дизайна (manager v3, Inventory addon). */
const CAPABILITIES: ReadonlyArray<Capability> = [
  {
    icon: '📦',
    title: 'Позиции и остатки',
    desc: 'Перечень позиций по категориям (продукты, текстиль, расходники, химия) с текущим остатком и точкой дозаказа.',
  },
  {
    icon: '🔁',
    title: 'Журнал движений',
    desc: 'История поступлений, списаний и перемещений — кто, когда и сколько, с фильтром по дате и причине.',
  },
  {
    icon: '🧾',
    title: 'Приёмка по чекам (OCR)',
    desc: 'Загрузка фото чека и автоматическое распознавание позиций для оприходования. Подключается отдельным этапом.',
  },
  {
    icon: '⚠️',
    title: 'Сигналы о нехватке',
    desc: 'Подсветка позиций ниже минимального остатка, чтобы вовремя пополнять запасы.',
  },
];

export function InventoryPage(): JSX.Element {
  return (
    <section data-testid="inventory-page">
      <h1 className="hsc-page__title">Склад</h1>

      <Card>
        <div className="inv-hero" data-testid="inventory-soon">
          <span className="inv-hero__icon" aria-hidden="true">
            📦
          </span>
          <div>
            <p className="inv-hero__title">Модуль склада готовится к запуску</p>
            <p className="ta-muted">
              Учёт остатков для отеля «Облака» подключается. Ниже — что будет доступно. Пока данных
              нет, поэтому списки и таблицы появятся после включения модуля — мы не показываем
              выдуманные позиции.
            </p>
          </div>
        </div>
      </Card>

      <h2 className="inv-section-title">Что появится в модуле</h2>
      <div className="inv-grid" data-testid="inventory-capabilities">
        {CAPABILITIES.map((c) => (
          <div key={c.title} className="inv-cap" data-testid={`inventory-cap-${c.title}`}>
            <span className="inv-cap__icon" aria-hidden="true">
              {c.icon}
            </span>
            <p className="inv-cap__title">{c.title}</p>
            <p className="inv-cap__desc">{c.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
